export default __webpack_public_path__ + "static/media/logo_posi.6b017a44.svg";